// src/registered/common/help/GlobalHelpDrawer.jsx
import React from 'react';
import { useHelp } from './HelpContext'; // Your context hook
import ReactMarkdown from 'react-markdown';

export default function GlobalHelpDrawer() {
  const { isOpen, closeHelp, helpConfig } = useHelp();

  // 🛡️ SECURITY: If the drawer isn't open or no config is defined, we render NOTHING.
  if (!isOpen || !helpConfig) return null;

  return (
    <>
      <div className="drawer-backdrop" onClick={closeHelp} />
      <div className={`help-drawer open`}>
        <div className="help-drawer-header d-flex justify-content-between align-items-center p-3 border-bottom">
           <div>
             <h5 className="fw-bold mb-0">{helpConfig.title}</h5>
             <small className="text-muted">Ref: {helpConfig.id}</small>
           </div>
           <button className="btn-close" onClick={closeHelp}></button>
        </div>
        <div className="help-drawer-body p-4 markdown-container">
           <ReactMarkdown>{helpConfig.content}</ReactMarkdown>
        </div>
      </div>
    </>
  );
}